import useAPI from '../core/hooks/useApi';

export default function useTokenSession() {
  const { data: tokenData, isLoading, error } = useAPI(`/api/auth/token`, {
    method: 'POST',
  });

  return { tokenData, isLoading, error };
}
